module.exports = __webpack_public_path__ + "img/12_1.b54c0dfc.png";